import { useDataChange } from 'Simple/Data.js'
export function useOnChooseAddress(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'carrier',
  })
  return function onChange({ street, city, state, zip }) {
    change(next => {
      next.postal_address.address_line1 = street || ''
      next.postal_address.city = city || ''
      next.postal_address.state = state || ''
      next.postal_address.zip = zip || ''
    })
  }
}
